import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { DefinisciFascicoloForm } from '../../../form/definisci-fascicolo-form.component';
import { DefinisciFascicoloRequest } from '../../../models/dto/definisci-fascicolo-request';
import { EsitoOperazione } from '../../../models/dto/esito-operazione-response';
import { Fascicolo } from '../../../models/fascicolo/fascicolo';
import { Pratica } from '../../../models/pratica/pratica';
import { StatoEntita } from '../../../models/tipologiche/stato-entita';

declare var getFascicoloMapSync;

@Component({
    selector: 'div [definisci-fascicolo-form]',
  templateUrl: '../../../form/definisci-fascicolo-form.component.html'
})

export class DefinisciFascicoloConcreteFormComponent extends DefinisciFascicoloForm {
  fascicolo: Fascicolo;
  pratica: Pratica;

  @Output() onReturn: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() onClickDatiGenerali: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor( @Inject(OperationsService) operationService, @Inject(FormBuilder) campiForm, @Inject(HelpersService) helpers: HelpersService) {
    super(operationService, campiForm, helpers);
  }

  ngOnInit() {
    this.setTitle('Definisci Fascicolo');
    this.isInserimento(false);
  }

  getFascicolo() {
    return this.fascicolo;
  }

  getRequest(definisciRequest: DefinisciFascicoloRequest) {
    if (this.fascicolo.dataDefinizione) {
      this.operationService.aggiornaDefinisciFascicolo(this.buildUrlDefinisci(), definisciRequest).subscribe(response => this.datiFascicolo(definisciRequest, response));
    } else {
      this.operationService.creaDefinisciFascicolo(this.buildUrlDefinisci(), definisciRequest).subscribe(response => this.datiFascicolo(definisciRequest, response));
    }
  }

  buildUrlDefinisci(): string {
    let fascicoloMap = this.getFascicoloFromMap(this.fascicolo.tipoFascicolo.id, this.pratica.tipoPratica.id);
    return fascicoloMap.pathDefine;
  }

  private getFascicoloFromMap(idTipoFascicoloMap: any, idTipoPraticaMap: any) {
    // let nomeFascicoloFE = FrontEndMapping.tipiFascicolo[idTipoFascicoloMap];
    // let nomePraticaFE = FrontEndMapping.tipiPratica[idTipoPraticaMap];
    let fascicolo = getFascicoloMapSync(idTipoPraticaMap, idTipoFascicoloMap);
    return fascicolo;
  }

  datiFascicolo(definisciRequest: DefinisciFascicoloRequest, response: EsitoOperazione) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.esito);
      this.fascicolo.definito = true;
      if (this.fascicolo.motivoDefinizione ) {
        this.fascicolo.motivoDefinizione.id = definisciRequest.idMotivoDefinizione;
      }else {
        this.fascicolo.motivoDefinizione = new StatoEntita();
        this.fascicolo.motivoDefinizione.id = definisciRequest.idMotivoDefinizione;
      }
      this.fascicolo.dataDefinizione = definisciRequest.dataDefinizione;
    }
  }

  inizializza(fascicolo: Fascicolo, pratica: Pratica) {
    this.fascicolo = fascicolo;
    this.pratica = pratica;
    this.populateSelect();
    this.createForm(this.fascicolo);
  }

  goToDatiGenerali() {
    this.onClickDatiGenerali.emit();
  }

}
